export const outMessage = 'OUT'
